/**
 * <p-motion data-motion="fade-up|fade-in|zoom"> — Scroll-Reveal wie Hyper <motion-element>.
 * Hyper-Werte: zoom (Hyper zoom-out/-sm, Bilder) = nur Opacity, 1 s; fade-up = translateY(2.5rem ≙ 25px) + Opacity, 0.5 s; fade-in = Opacity, 1.5 s;
 * Easing cubic-bezier(0, 0, 0.3, 1); IntersectionObserver rootMargin 0 0 -80px 0.
 * Verschachtelte Elemente starten erst, wenn das Eltern-Element sichtbar wurde.
 */
if (!customElements.get('p-motion')) {
  const P_MOTION_OFF = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(0, 0, 0.3, 1)';
  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              entry.target.reveal();
            });
          },
          { rootMargin: '0px 0px -80px 0px' }
        )
      : null;

  class PMotion extends HTMLElement {
    connectedCallback() {
      // Aus (Daniel 25.09.): Lade-Animationen 1:1 wie CallMePuppy → Texte stehen sofort, Bilder blendet
      // p-image-reveal.js ein. Element bleibt als neutraler Wrapper; zum Reaktivieren diese Zeile entfernen.
      if (P_MOTION_OFF) return;
      if (reduced || !observer || window.Shopify?.designMode || this.dataset.shown) return;
      const type = this.dataset.motion || 'fade-up';
      this.style.visibility = 'hidden';
      this.style.opacity = '0.01';
      if (type === 'fade-up') this.style.transform = 'translateY(25px)';
      const parent = this.parentElement?.closest('p-motion');
      if (parent && !parent.dataset.shown) {
        parent.addEventListener('p-motion:shown', () => observer.observe(this), { once: true });
      } else {
        observer.observe(this);
      }
    }

    disconnectedCallback() {
      observer?.unobserve(this);
    }

    reveal() {
      const type = this.dataset.motion || 'fade-up';
      const duration = type === 'fade-in' ? 1.5 : type === 'zoom' ? 1 : 0.5;
      this.dataset.shown = 'true';
      this.dispatchEvent(new CustomEvent('p-motion:shown'));
      this.style.visibility = 'visible';
      this.style.transition = `opacity ${duration}s ${EASE}, transform ${duration}s ${EASE}`;
      void this.offsetWidth; // Startwerte festschreiben, damit die Transition greift
      this.style.opacity = '';
      this.style.transform = '';
      setTimeout(() => {
        this.style.transition = '';
        this.style.visibility = '';
      }, duration * 1000 + 50);
    }
  }

  customElements.define('p-motion', PMotion);
}
